import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';
import { Settings } from 'lucide-react';

export const SettingsDialog = ({ open, onOpenChange, post, setPost }) => {
  const P = post || {};
  const update = (k, v) => setPost({ ...P, [k]: v });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg bg-card border-border">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Settings className="h-4 w-4 text-primary" /> Posztprocesszor beallitasok (Mach3)</DialogTitle>
          <DialogDescription className="text-xs text-muted-foreground">Mach3 posztprocesszor beallitasok.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label className="text-xs">Egyseg</Label>
            <Select value={P.units || 'mm'} onValueChange={v => update('units', v)}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="mm">mm (G21)</SelectItem>
                <SelectItem value="inch">inch (G20)</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs">WCS</Label>
            <Select value={P.wcs || 'G54'} onValueChange={v => update('wcs', v)}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                {['G54','G55','G56','G57','G58','G59'].map(w => <SelectItem key={w} value={w}>{w}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div><Label className="text-xs">Tizedes helyek</Label><Input type="number" min="1" max="6" value={P.decimals || 4} onChange={e => update('decimals', parseInt(e.target.value || '4', 10))} /></div>
          <div><Label className="text-xs">Biztonsagi Z (mm)</Label><Input type="number" value={P.safe_z ?? 25} onChange={e => update('safe_z', parseFloat(e.target.value))} /></div>
          <div><Label className="text-xs">Retract Z (mm)</Label><Input type="number" value={P.retract_z ?? 25} onChange={e => update('retract_z', parseFloat(e.target.value))} /></div>
          <div className="col-span-2 flex items-center justify-between p-2 rounded border border-border/60 bg-black/20">
            <div>
              <Label className="text-xs">Hutes (M08/M09)</Label>
              <p className="text-[10px] text-muted-foreground">Automatikus M08 (be) / M09 (ki)</p>
            </div>
            <Switch checked={!!P.coolant} onCheckedChange={v => update('coolant', v)} />
          </div>
          <div className="col-span-2 flex items-center justify-between p-2 rounded border border-border/60 bg-black/20">
            <div>
              <Label className="text-xs">Sorszamok (N####)</Label>
              <p className="text-[10px] text-muted-foreground">Blokk sorszam minden sorra</p>
            </div>
            <Switch checked={!!P.use_line_numbers} onCheckedChange={v => update('use_line_numbers', v)} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsDialog;
